import { render, staticRenderFns } from "./UpdateVersionPopup.vue?vue&type=template&id=1c571b3b&"
import script from "./UpdateVersionPopup.vue?vue&type=script&lang=ts&"
export * from "./UpdateVersionPopup.vue?vue&type=script&lang=ts&"
import style0 from "./UpdateVersionPopup.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports